// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatActionButton__container__3scTJ","btn":"ChatActionButton__btn__NfFBZ","btnEmbed":"ChatActionButton__btnEmbed__IW5lN","timer":"ChatActionButton__timer__Cpfzu"};